import React from 'react';
import PropTypes from 'prop-types';
import { useIntl } from 'react-intl';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

const Button = ({ value, text, className, children, ariaLabel, ...props }) => <button
  type="button"
  value={ value }
  aria-label={ ariaLabel ?? value }
  className={ `btn ${ className != null ? className : '' }` }
  { ...props }
>
  { text != null ? text : value }
  { children }
</button>;

Button.propTypes = {
  value: PropTypes.string.isRequired,
  text: PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.node),
    PropTypes.node
  ]),
  ariaLabel: PropTypes.string
};

Button.defaultProps = {
  text: null,
  className: null,
  children: null,
  ariaLabel: null
};

export const SubmitButton = ({ value, text, className, children, ...props }) => <button
  type="submit"
  aria-label={ value }
  className={ `btn ${ className != null ? className : '' }` }
  { ...props }
>
  { text != null ? text : value }
  { children }
</button>;

SubmitButton.propTypes = {
  value: PropTypes.string.isRequired,
  text: PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.node),
    PropTypes.node
  ])
};

SubmitButton.defaultProps = {
  text: null,
  className: null,
  children: null
};

export const TileButton = ({ value, text, icon, className, selected, ...props }) => <button
  type="button"
  aria-label={ value }
  className={ `btn tile ${ className != null ? className : '' } ${ selected ? 'selected' : '' }` }
  { ...props }
>
  <FontAwesomeIcon icon={ icon } className={ selected ? 'wide' : '' } />
  <span>{ text != null ? text : value }</span>
</button>;

TileButton.propTypes = {
  value: PropTypes.string.isRequired,
  icon: PropTypes.string.isRequired,
  text: PropTypes.string,
  className: PropTypes.string,
  selected: PropTypes.bool
};

TileButton.defaultProps = {
  text: null,
  className: null,
  selected: false
};

export const HintButton = ({
  hintType,
  active,
  onClick,
  className,
  hintLabel,
}) => {
  const intl = useIntl();
  function getHintButtonLabel() {
    if (!(hintLabel?.trim().length)) {
      return hintType;
    }

    const hintFor = intl.formatMessage({ id: 'hintFor' });
    return `${ hintFor }${ hintLabel.replace('*', '').trim() }`;
  }

  return (
    <button
      value={ hintType }
      type="button"
      aria-label={ getHintButtonLabel() }
      onClick={ () => onClick() }
      className={ `btn hint ${ active ? 'active' : '' } ${ className != null ? className : '' }` }
    >
      { hintType === 'hint' && <FontAwesomeIcon icon={ active ? 'info-circle' : 'info' } size="2xs" className={ `icon ${ !active ? 'i-info-inactive' : '' }` } /> }
      { hintType === 'info' && <FontAwesomeIcon icon={ active ? 'info-circle' : 'info' } size="2xs" className={ `icon ${ !active ? 'i-info-inactive' : '' }` } /> }
      { hintType === 'tip' && <FontAwesomeIcon icon="lightbulb" size="2xs" className={ `icon ${ !active ? 'i-info-inactive' : '' }` } /> }
      { hintType === 'caution' && <FontAwesomeIcon icon={ active ? 'exclamation-circle' : 'exclamation' } size="2xs" className={ `icon ${ !active ? 'i-info-inactive' : '' }` } /> }
    </button>
  );
};

HintButton.propTypes = {
  hintType: PropTypes.string.isRequired,
  active: PropTypes.bool.isRequired,
  onClick: PropTypes.func.isRequired,
  className: PropTypes.string,
  hintLabel: PropTypes.string,
};

HintButton.defaultProps = {
  className: null,
  hintLabel: null
};

export default Button;
